import styled from 'styled-components'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return ![...DIV_SHOULD_FORWARD_PROP, 'pointerCursor'].includes(String(prop))
}

export const Container = styled(Flex)
  .attrs({
    mt: [16, 16, 0],
    justifyContent: ['center', 'center', 'flex-start'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  height: 100%;
  width: 100%;
  align-items: center;
`
